import { normalizeStatus, toBatchDetail, toCycleRow } from "./batchAdapters";

export const BATCH_STATUS = { CREATED: "Created", WIP: "WIP", HOLD: "Hold", COMPLETED: "Completed" };
export const STATUS_LIST = Object.values(BATCH_STATUS);
export const getBatchUid = row => row?.uid ?? row?._id ?? row?.id ?? row?.batch_id;
export const deriveBatchStatus = row => normalizeStatus(row?.status ?? (row?.dispatch_on ? "completed" : "created"));
export const deriveBatchProgress = row => toBatchDetail(row)?.progress ?? 0;
export const deriveNgPartsCount = row => row?.hold_parts ?? row?.ng_parts ?? null;
export const deriveProcessTimeMinutes = row => toBatchDetail(row)?.currentProcessTimeMinutes ?? null;
export const deriveYieldRate = row => toBatchDetail(row)?.yieldRate ?? null;
export const deriveBatchTimeline = row => toBatchDetail(row)?.timeline ?? [];
export const derivePartRecords = row => (row?.cycles || []).map(toCycleRow);
